import React from 'react'
import classNames from 'classnames'
import generalClasses from './Settings.module.css'
import gridClasses from '../../../styles/grid.module.css'
import { AuthenticatedHeader } from '../../../components/Header/AuthenticatedHeader'
import { NavLink, Switch, Route, Redirect } from 'react-router-dom'
import BusinessSettingsBasic from './Basics'
import BusinessSettingsLogo from './Logo'
import BusinessSettingsBilling from './Billing'
import BusinessSettingsPaymentMethod from './PaymentMethod'

const links = [
    {
        title: 'Basics',
        route: 'basics',
        component: BusinessSettingsBasic,
    },
    {
        title: 'Logo',
        route: 'logo',
        component: BusinessSettingsLogo,
    },
    {
        title: 'Billing',
        route: 'billing',
        component: BusinessSettingsBilling,
    },
]

const BusinessSettingsWrapper = ({ match }) => {
    const { path } = match
    return (
        <React.Fragment>
            <AuthenticatedHeader isBusinessOwner={true} />
            <main className={generalClasses.pageContent}>
                <div className={gridClasses.container}>
                    <h1 className={generalClasses.pageTitle}>Settings</h1>
                    <nav className={generalClasses.tabRow}>
                        {links.map(link => (
                            <NavLink
                                className={generalClasses.tabItem}
                                to={`${path}/${link.route}`}
                            >
                                {link.title}
                            </NavLink>
                        ))}
                    </nav>
                </div>
                <section className={generalClasses.tabContent}>
                    <div
                        className={classNames(
                            gridClasses.container,
                            gridClasses.containerTransparent
                        )}
                    >
                        <Switch>
                            {links
                                .filter(link => !!link.component)
                                .map(link => (
                                    <Route
                                        path={`${path}/${link.route}`}
                                        component={link.component}
                                    />
                                ))}
                            <Route
                                path={path}
                                render={() => (
                                    <Redirect
                                        to={`${path}/${links[0].route}`}
                                    />
                                )}
                                exact
                            />
                        </Switch>
                    </div>
                </section>
            </main>
        </React.Fragment>
    )
}

export default BusinessSettingsWrapper
